(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    const compactFilters = window.matchMedia('(max-width: 749px)');
  const mobileFilterPanels = () => document.querySelectorAll('body:has(.main-collection-grid) .facets--horizontal details[open]');
  document.addEventListener('toggle', (event) => {
    const panel = event.target;
    if (!compactFilters.matches || !(panel instanceof HTMLDetailsElement) || !panel.open) return;
    if (!panel.closest('body:has(.main-collection-grid) .facets--horizontal')) return;
    mobileFilterPanels().forEach((other) => {
      if (other !== panel) other.open = false;
    });
  }, true);
  document.addEventListener('pointerdown', (event) => {
    if (!compactFilters.matches || !(event.target instanceof Element)) return;
    if (!event.target.closest('.facets--horizontal')) {
      mobileFilterPanels().forEach((panel) => { panel.open = false; });
    }
  });
  document.addEventListener('keydown', (event) => {
    if (!compactFilters.matches || event.key !== 'Escape') return;
    mobileFilterPanels().forEach((panel) => {
      panel.open = false;
      panel.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
